// Enable reading the Provider props from other element such as Canvas.

import { createContext } from 'react';
import { ProviderProps } from './types';

// This is not meant to be exported
export const ProviderPropsContext = createContext<ProviderProps>({});
